import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { DataTableColumn, PaginatorStatus, SortConfiguration } from '../generics/data-table/data-table.component';
import { CustomTableFilter } from '../generics/table-filter/table-filter.component';
import { ErrorResponse } from 'src/app/models/error.model';
import { Comercial } from 'src/app/models/comercial.model';
import { ComercialesService } from 'src/app/services/comerciales.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
    selector: 'app-comerciales',
    templateUrl: './comerciales.component.html',
    styleUrls: ['./comerciales.component.scss']
})
export class ComercialesComponent implements OnInit {

    @ViewChild('actionsColumnTemplate', { static: true })
    actionsColumnTemplate: TemplateRef<any>;

    @ViewChild('activoColumnTemplate', { static: true })
    activoColumnTemplate: TemplateRef<any>;

    paginatorStatus: PaginatorStatus = {
        itemsPerPage: 50,
        page: 0,
        totalElementCount: 0
    };

    columns: DataTableColumn[] = [
        { name: 'Apellido', prop: 'apellido', sortable: true },
        { name: 'Nombre', prop: 'nombre', sortable: true },
        { name: 'Email', prop: 'email', sortable: true },
        { name: 'Teléfono', prop: 'telefono' },
        { name: 'Estado', width: '100px' },
        { name: '', width: '100px' }
    ];

    sortConfiguration?: SortConfiguration;
    comerciales: Comercial[] = [];

    filters: CustomTableFilter[] = [
        { key: 'nombre', description: 'Nombre / Apellido', type: 'STRING' }
    ];
    filterValues: any = {};

    constructor(
        private comercialesService: ComercialesService,
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.columns.find(col => col.name === 'Estado').template = this.activoColumnTemplate;
        this.columns.find(col => col.name === '').template = this.actionsColumnTemplate;
        this.getComerciales();
    }

    getComerciales() {
        this.comercialesService.getComerciales(
            this.paginatorStatus.page,
            this.paginatorStatus.itemsPerPage,
            this.sortConfiguration ? [this.sortConfiguration] : [],
            { ...this.filterValues, 'ocultar-inactivos': 'false' }
        ).subscribe({
            next: response => {
                this.paginatorStatus.totalElementCount = parseInt(response.headers.get('pagination-total-count') ?? '0', 10);
                this.comerciales = response.body;
            },
            error: (error: ErrorResponse) => this.utilsService.alert('Error al obtener comerciales', error.error?.descripcion)
        });
    }

    updatePage(event: PageEvent) {
        this.paginatorStatus.itemsPerPage = event.pageSize;
        this.paginatorStatus.page = event.pageIndex;
        this.getComerciales();
    }

    updateSort(event: SortConfiguration) {
        this.sortConfiguration = event;
        this.getComerciales();
    }

    setFilterValues(values: any) {
        this.filterValues = values;
        this.getComerciales();
    }

    deleteComercial(comercial: Comercial) {
        const dialog = this.utilsService.confirm(
            '¿Dar de baja este comercial?',
            `El comercial "${comercial.nombre} ${comercial.apellido}" quedará inactivo.`
        );
        dialog.afterClosed().subscribe(confirmed => {
            if (confirmed) {
                this.comercialesService.deleteComercial(comercial.id).subscribe({
                    next: () => {
                        this.utilsService.alert('Comercial dado de baja', `"${comercial.nombre} ${comercial.apellido}" fue dado de baja correctamente.`);
                        this.getComerciales();
                    },
                    error: (error: ErrorResponse) => this.utilsService.alert('Error al dar de baja el comercial', error.error?.descripcion)
                });
            }
        });
    }
}
